<template>
  <!-- 顶层始终渲染 App(只初始化一次, 永不因 resize 重挂载 → 不会卡在启动骨架)。
       手机壳档(390–1024, 仅顶层窗口)时, 用一个全屏 iframe 遮罩盖在 App 之上, 显示真实
       390 视口的移动版; 离开该档遮罩移除, 露出底层 App(PC / 原生移动)。
       iframe 内(IS_FRAMED)不套壳。 -->
  <App />
  <PhoneFrameShell v-if="showPhoneFrame" />
</template>

<script setup>
  import {computed} from 'vue';
  import App from '@/App.vue';
  import PhoneFrameShell from '@/components/utils/PhoneFrameShell.vue';
  import {useResponsive, IS_FRAMED} from '@/hooks/useResponsive.js';

  const {phoneFrameMode} = useResponsive();
  const showPhoneFrame = computed(() => phoneFrameMode.value && !IS_FRAMED);
</script>
